export const ADD_TEXT = 'ADD_TEXT';
export const SAVE_TEXT_PROPERTIES = 'SAVE_TEXT_PROPERTIES';
export const LOAD_TEXTS_BY_BOOK_ID = 'LOAD_TEXTS_BY_BOOK_ID';
export const TOGGLE_TEXT_ACTIVE = 'TOGGLE_TEXT_ACTIVE';
export const CHANGE_TEXT_PROPERTY = 'CHANGE_TEXT_PROPERTY';
export const DELETE_TEXT = 'DELETE_TEXT';
export const CHANGE_EVERY_TEXT_PROPERTY = 'CHANGE_EVERY_TEXT_PROPERTY';




// WEBPACK FOOTER //
// ./src/redux/action-types/entities/texts.js